import type { Job } from "@kanda-libs/ks-frontend-services";
import { useSelector } from "react-redux";
import jobSelectors from "store/selectors/job";
import { selectors } from "store";

export interface JobStatusPropsHook {
  archived: boolean;
  timestamp?: Date;
  status: Job["status"];
  isLoading: boolean;
}

export default function useJobStatusProps(): JobStatusPropsHook {
  const job = useSelector(jobSelectors.getEntity);
  const isLoading = useSelector(selectors.getIsLoading);

  return {
    archived: job?.archived === "yes",
    timestamp: job?.metadata?.updated_at,
    status: job?.status || "draft",
    isLoading,
  };
}
